import { Typography, Grid } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RoundedPaper } from '../../../lib/components';
import { ReceiptStatusBadge } from '../../../lib/components/compound/dataDisplay/receiptStatusBadge';
import { ReceiptStatusEnum } from '@pxtra-client-lib-legacy/gen';

interface StatusProps {
  count?: number;
  onClick?: () => void;
}

export interface Props {
  submitted?: StatusProps;
  approved?: StatusProps;
  billed?: StatusProps;
  rejected?: StatusProps;
  orientation?: 'row' | 'column';
  selectedItem?: ReceiptStatusEnum;
}

export const ReceiptStatusWidget: FC<Props> = ({
  submitted,
  approved,
  billed,
  rejected,
  orientation = 'row',
  selectedItem
}) => {
  const { t } = useTranslation();
  const size = orientation === 'row' ? 3 : 12;
  return (
    <RoundedPaper sx={{ padding: '24px' }}>
      <Typography variant="h3" paddingBottom="16px">
        {t('receipts:STATUS')}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={size}>
          <ReceiptStatusBadge
            status="SUBMITTED"
            {...submitted}
            disabled={selectedItem && selectedItem != 'SUBMITTED'}
            outline={selectedItem == 'SUBMITTED'}
            dataTestId="receipt-status-submitted"
          />
        </Grid>
        <Grid item xs={size}>
          <ReceiptStatusBadge
            status="APPROVED"
            {...approved}
            disabled={selectedItem && selectedItem != 'APPROVED'}
            outline={selectedItem == 'APPROVED'}
            dataTestId="receipt-status-approved"
          />
        </Grid>
        <Grid item xs={size}>
          <ReceiptStatusBadge
            status="BILLED"
            {...billed}
            disabled={selectedItem && selectedItem != 'BILLED'}
            outline={selectedItem == 'BILLED'}
            dataTestId="receipt-status-billed"
          />
        </Grid>
        <Grid item xs={size}>
          <ReceiptStatusBadge
            status="REJECTED"
            {...rejected}
            disabled={selectedItem && selectedItem != 'REJECTED'}
            outline={selectedItem == 'REJECTED'}
            dataTestId="receipt-status-rejected"
          />
        </Grid>
      </Grid>
    </RoundedPaper>
  );
};
